import { ISocialPage } from "./SocialPages";

export class WebsiteInformation {
    constructor(
        public name: string,
        /* Website url with https but NO TRAILING SLASH */        
        public siteUrl: string,
        public siteLogoUrl: string,
        public siteLogoUrlSquare: string,
        public socialPages: ISocialPage[],
    ){

    }
}